(function(){
	'use strict';

	angular
	.module('app', [
		'ui.router',
		'ksSwiper',
		'ui.utils.masks',
		'angulartics',
		'angulartics.google.analytics',
		'angularUtils.directives.dirPagination',
		'app.products',
		'app.news',
		'app.contact',
		'file-model'
	])

})();
